// extracted by mini-css-extract-plugin
module.exports = {"language-wrapper":"LanguageToggle_language-wrapper__OjsA_"};